var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6415F",
    fillRule: "evenodd",
    d: "M12 5.00773L10.6039 4.71741L10.1629 3.65083L10.9443 2.45913L9.54088 1.05571L8.34912 1.83716L7.28278 1.39599L6.99246 0H5.00754L4.71722 1.39599L3.65088 1.83716L2.45912 1.05571L1.0557 2.45913L1.83715 3.65083L1.39606 4.71741L0 5.00773V6.99235L1.39606 7.28267L1.83715 8.34925L1.0557 9.54095L2.45912 10.9444L3.65072 10.1629L4.71722 10.6041L5.00754 12H6.99246L7.28278 10.6041L8.34928 10.1629L9.54088 10.9444L10.9443 9.54095L10.1629 8.34925L10.6039 7.28267L12 6.99235V5.00773ZM2.82293 7.63715L3.0443 6.88257H4.16545L4.37969 7.63715H5.33184L4.17736 4.20227H3.10857L1.95647 7.63715H2.82293ZM4.00121 6.25415H3.21093L3.58702 4.97589H3.63225L4.00121 6.25415ZM6.55648 7.63715V6.63025H7.13491C7.89901 6.63025 8.42507 6.15179 8.42507 5.42102C8.42507 4.68311 7.9252 4.20227 7.18728 4.20227H5.68289V7.63715H6.55648ZM6.95162 5.97089H6.55648V4.87354H6.95639C7.32534 4.87354 7.54196 5.06158 7.54196 5.4234C7.54196 5.78046 7.32296 5.97089 6.95162 5.97089ZM9.71399 7.63715V4.20227H8.84039V7.63715H9.71399Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiColored);
export default __webpack_public_path__ + "static/media/api-colored.4e1d3230bad552c6b496321ee1fab4e7.svg";
export { ForwardRef as ReactComponent };